var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center py-5 mt-4"},[_c('Adsense',{staticStyle:{"display":"block"},attrs:{"data-ad-client":"ca-pub-3836360070739170","data-ad-slot":"3150440110","data-ad-format":"auto","data-full-width-responsive":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }